import styled from 'styled-components'
import { colors, measurments } from '../utils/config'
import { PropsWithChildren } from 'react'
import { LucideIconName } from '@bm-js/atlascloud-shared'
import { Icon } from '@bm-js/atlascloud-ui'

const StyledLinkButton = styled.button<{ $reverse?: boolean }>`
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  border: none;
  color: ${colors.primary400};
  background: none;
  border-radius: ${measurments.borderRadius}px;
  font-size: 0.9rem;
  gap: 0.5rem;
  &:hover {
    text-decoration: underline;
  }
  display: flex;
  align-items: center;
  ${({ $reverse }) => ($reverse ? 'flex-direction: row-reverse;' : '')}
`

interface Props extends React.HTMLProps<HTMLButtonElement> {
  icon?: LucideIconName
  reverse?: boolean
  type?: 'button' | 'submit' | 'reset'
}

const LinkButton = (props: PropsWithChildren<Props>) => {
  const { icon, reverse, type, children, ...linkProps } = props
  return (
    <StyledLinkButton {...linkProps} $reverse={reverse} type={type || 'button'}>
      {children}
      {icon && <Icon name={icon} className='size-5' />}
    </StyledLinkButton>
  )
}

export default LinkButton
